(() => {
  'use strict';
  if (window.NLVLaunchOffer) { window.NLVLaunchOffer.init(document); return; }
  const instances = new Map();
  const motion = matchMedia('(prefers-reduced-motion: reduce)');
  const animated = new WeakSet();
  const reveal = offer => { if (animated.has(offer)) return; animated.add(offer); if (!motion.matches) offer.classList.add('is-launch-animated'); };
  const intersection = 'IntersectionObserver' in window ? new IntersectionObserver(entries => entries.forEach(entry => { if (entry.isIntersecting) { reveal(entry.target); intersection.unobserve(entry.target); } }), { threshold: .35 }) : null;
  const animate = scope => scope.querySelectorAll('[data-launch-offer]').forEach(offer => { if (intersection) intersection.observe(offer); else reveal(offer); });
  const init = scope => {
    animate(scope);
    scope.querySelectorAll('[data-launch-poster]').forEach(element => {
      if (instances.has(element)) return;
      const dialog = element.querySelector('[data-launch-dialog]');
      if (!dialog || typeof dialog.showModal !== 'function') return;
      const abort = new AbortController();
      const options = { signal: abort.signal };
      const editor = Boolean(window.Shopify?.designMode);
      const key = `nlv-launch-dismissed:${element.dataset.launchKey}`;
      let previousFocus, previousOverflow = '', timer, disposed = false, ready = false, opened = false, manual = false, quietUntil = 0;
      const dismissed = () => { try { return sessionStorage.getItem(key) === '1'; } catch (_) { return false; } };
      const remember = () => { try { sessionStorage.setItem(key, '1'); } catch (_) {} };
      const busy = () => Boolean(document.querySelector('[data-intro]:not([hidden]), dialog[open]:not([data-launch-dialog]), [data-purchase-toast]:not([hidden])')) || Boolean(document.querySelector('[data-nlv-privacy]') && (!window.NLVPrivacy?.ready || window.NLVPrivacy.nativeVisible?.() || window.NLVPrivacy.needsChoice?.()));
      const open = () => {
        if (disposed || dialog.open || busy() || document.visibilityState !== 'visible') return false;
        previousFocus = document.activeElement;
        previousOverflow = document.body.style.overflow;
        dialog.showModal();
        document.body.style.overflow = 'hidden';
        dialog.querySelector('[data-launch-close]')?.focus({ preventScroll: true });
        opened = true;
        animate(dialog);
        return true;
      };
      const attempt = () => {
        if (disposed || !ready || opened && !manual || !manual && dismissed()) return;
        if (!manual && Date.now() < quietUntil) { clearTimeout(timer); timer = setTimeout(attempt, quietUntil - Date.now()); return; }
        if (open()) manual = false;
      };
      const close = () => { if (dialog.open) dialog.close(); };
      element.querySelectorAll('[data-launch-close]').forEach(button => button.addEventListener('click', close, options));
      element.querySelector('[data-launch-cta]')?.addEventListener('click', remember, options);
      dialog.addEventListener('close', () => {
        remember();
        if (!document.querySelector('dialog[open], [data-intro]:not([hidden])')) { document.body.style.overflow = previousOverflow; previousFocus?.focus?.({ preventScroll: true }); }
      }, options);
      dialog.addEventListener('click', event => {
        if (event.target !== dialog) return;
        const rect = dialog.getBoundingClientRect();
        if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) close();
      }, options);
      document.addEventListener('click', event => {
        if (!event.target.closest?.('[data-launch-open]')) return;
        event.preventDefault(); manual = true; ready = true; attempt();
      }, options);
      document.addEventListener('close', event => {
        if (!(event.target instanceof HTMLDialogElement) || event.target === dialog) return;
        quietUntil = Date.now() + 15000;
        if (ready) { clearTimeout(timer); timer = setTimeout(attempt, 15000); }
      }, { ...options, capture: true });
      document.addEventListener('visibilitychange', attempt, options);
      document.addEventListener('nlv:privacy:ready', () => { quietUntil = Date.now() + 15000; if (ready) { clearTimeout(timer); timer = setTimeout(attempt, 15000); } }, options);
      const observer = new MutationObserver(records => {
        // Removing another dialog's open attribute is observed before its close
        // event. Start the quiet period here so two popups cannot appear in succession.
        if (records.some(record => record.attributeName === 'open' && record.target instanceof HTMLDialogElement && record.target !== dialog && !record.target.open)) quietUntil = Date.now() + 15000;
        attempt();
      });
      observer.observe(document.body, { subtree: true, attributes: true, attributeFilter: ['hidden', 'open'] });
      if (!editor && !dismissed()) timer = setTimeout(() => { ready = true; attempt(); }, Math.max(0, (Number(element.dataset.launchDelay) || 8) * 1000 - (scope === document ? performance.now() : 0)));
      instances.set(element, { open: () => { manual = true; ready = true; attempt(); }, dispose: () => { disposed = true; clearTimeout(timer); observer.disconnect(); close(); abort.abort(); instances.delete(element); } });
    });
  };
  window.NLVLaunchOffer = { init };
  init(document);
  document.addEventListener('shopify:section:load', event => init(event.target));
  document.addEventListener('shopify:section:select', event => event.target.querySelectorAll('[data-launch-poster]').forEach(element => instances.get(element)?.open()));
  document.addEventListener('shopify:section:unload', event => {
    event.target.querySelectorAll('[data-launch-poster]').forEach(element => instances.get(element)?.dispose());
    event.target.querySelectorAll('[data-launch-offer]').forEach(offer => intersection?.unobserve(offer));
  });
})();
